var map = {
	"./Certificate.svg": 69607,
	"./Collection.svg": 96793,
	"./Collection_active.svg": 97602,
	"./PKbi.svg": 79900,
	"./Recharge.svg": 74145,
	"./activity.svg": 16063,
	"./android.svg": 56365,
	"./biaoqian.svg": 79810,
	"./card.svg": 22853,
	"./chengyuan.svg": 83102,
	"./chongzhi.svg": 80337,
	"./customer_service.svg": 92069,
	"./download.svg": 53048,
	"./game_exchange.svg": 10027,
	"./gift.svg": 35789,
	"./growth.svg": 89152,
	"./help.svg": 51156,
	"./home.svg": 37349,
	"./huanyihuan.svg": 63309,
	"./huojian.svg": 49396,
	"./integral.svg": 26330,
	"./ios.svg": 69146,
	"./jifen.svg": 12121,
	"./kefu.svg": 48986,
	"./left.svg": 94327,
	"./message.svg": 89664,
	"./my.svg": 4363,
	"./out.svg": 12633,
	"./password.svg": 63562,
	"./pc.svg": 16454,
	"./phone.svg": 93415,
	"./photo.svg": 86706,
	"./play.svg": 93449,
	"./ptbi.svg": 24547,
	"./qiandao.svg": 55031,
	"./qiandao1.svg": 26733,
	"./red.svg": 31653,
	"./right.svg": 68184,
	"./search.svg": 63761,
	"./succeed.svg": 71770,
	"./swpleft.svg": 21540,
	"./swpright.svg": 43439,
	"./user_compile.svg": 21299,
	"./wechat.svg": 34971,
	"./xiaofeidian.svg": 5652,
	"./zuanshi.svg": 34654,
	"./信息.svg": 77337,
	"./资料.svg": 3823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;